module.exports = __webpack_public_path__ + "static/img/4.441db17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/4.png
// module id = izmG
// module chunks = 1 3